const fromNearestStoresQueryToNearestStores = (nearestStoresQueryData)=>{
    if (!nearestStoresQueryData) {
        return null;
    }
    try {
        return nearestStoresQueryData.map((entry)=>{
            const { code , slug , town , shortName , storeDetailImage , distance , breadcrumbName , breadcrumbSlug ,  } = entry;
            const isDistanceInMeters = (value)=>typeof value === 'number'
            ;
            return {
                code,
                town,
                shortName,
                distance: isDistanceInMeters(distance) ? distance : undefined,
                slug: slug !== null && slug !== void 0 ? slug : undefined,
                detailImage: storeDetailImage !== null && storeDetailImage !== void 0 ? storeDetailImage : undefined,
                groupName: breadcrumbName !== null && breadcrumbName !== void 0 ? breadcrumbName : undefined,
                groupPath: breadcrumbSlug !== null && breadcrumbSlug !== void 0 ? breadcrumbSlug : undefined
            };
        });
    } catch (e) {
        console.error('Store search query data adapter failed to parse input data correctly.', e, nearestStoresQueryData);
        return null;
    }
};

export { fromNearestStoresQueryToNearestStores as default, fromNearestStoresQueryToNearestStores };
//# sourceMappingURL=fromNearestStoresQueryToNearestStores.js.map
